module.exports = __webpack_public_path__ + "static/media/sign-in_background.c3248ac4.png";